import React from 'react';
import { Section, SectionTitle } from '../Section';
import { ImageSlot } from '../ImageSlot';
import { IMAGES } from '../../data/landing';
export function GuideSection() {
  return <Section tone="wine" data-id="element-56" data-mp="1y49z66yl4qzb">
      <div className="grid gap-8 md:grid-cols-[5fr_6fr] md:items-center md:gap-12" data-id="element-57" data-mp="1y4t8x0e30929">
        <ImageSlot name="Beatriz Espina, la DOC" aspect="aspect-[3/4]" src={IMAGES.doc} className="mx-auto max-w-[300px] md:max-w-none" data-id="element-58" data-mp="1t4yggsenrbf3" />
        <div className="text-center md:text-left" data-id="element-59" data-mp="11ek5p51xyf7n">
          <SectionTitle data-id="element-60" data-mp="11fvbtbiuzz1x">
            Beatriz Espina, <em className="italic text-gold" data-id="element-61" data-mp="1fe1x7s6mg6kp">la DOC</em>
          </SectionTitle>
          <p className="mt-5 text-[17px] leading-relaxed text-ivory/90" data-id="element-62" data-mp="1fbz2wvyfrra6">
            Sexóloga con 17 años educando sobre sexualidad, con un método claro y sin juicios.
          </p>
          <blockquote className="mt-7 font-serif text-[1.75rem] italic leading-snug text-gold" data-id="element-63" data-mp="2qrdwrqvcm312">
            "Las manos dejan huellas imborrables."
          </blockquote>
        </div>
      </div>
    </Section>;
}